export default "__VITE_ASSET__CRHmqJrs__"